const englishTranslations = {
  title: "Diet Information",
  other: "Others",
  otherText: "If others, please specify",
  nota: "None of the above",
  yes: "Yes",
  yesText: "If yes please tell us more",
  no: "No",
  submitText1:
    "You have successfully registered for medical consultation with Doctor",
  submitText2: "Submitting information, please wait",
  submit: "Submit",
  updateInfo: "Update Info",
  noInfo: "No health information submitted",
  loadingInfo: "Fetching health information",
  D1: {
    question:
      "What best describes the type of work or daily activity at your job?",
    options: {
      D1C1: "Sedentary",
      D1C2: "Light activity",
      D1C3: "Physically Demanding",
      D1C4: "Unemployed",
      D1C5: "Retired",
      D1C6: "Student",
      D1C7: "Homemaker",
    },
  },
  D2: {
    question: "Does your job has shift base work?",
    options: {
      D2C1: "Fixed Day Shift",
      D2C2: "Fixed Night Shift",
      D2C3: "Varies Rotationally",
      D2C4: "No fixed hours of working",
    },
  },
  D3: {
    question: "Do you have any of the following digestive problems?",
    options: {
      D3C1: "Bloating",
      D3C2: "Gas",
      D3C3: "Constipation",
      D3C4: "Acidity",
      D3C5: "None of these",
    },
  },
  D4: {
    question: "Are you allergic to any food?",
  },
  D5: {
    question: "Select if you Consume the following",
    options: {
      D5C1: "Alcohol",
      D5C2: "Tobacco",
      D5C3: "Aerated/Cold drinks",
      D5C4: "None of these",
    },
  },
  D6: {
    question: "How fast do you chew food?",
    options: {
      D6C1: "Slow",
      D6C2: "Medium",
      D6C3: "Fast",
    },
  },
  D7: {
    question: "How much water do you drink every day?",
    options: {
      D7C1: "Less than 6 glasses",
      D7C2: "6 to 8 glasses",
      D7C3: "More than 8 glasses",
    },
  },
  D8: {
    question: "How much mental stress do you have?",
    options: {
      D8C1: "No stress",
      D8C2: "Sensitive nature",
      D8C3: "Low",
      D8C4: "Medium",
      D8C5: "High",
    },
  },
  D9: {
    question: "For women: Please provide menstrual information.",
    options: {
      D9C1: "Regular",
      D9C2: "Irregular",
      D9C3: "Not Applicable",
    },
  },
};

const marathiTranslations = {
  title: "आहार माहिती",
  other: "इतर",
  otherText: "जर इतर असतील तर, कृपया त्याचा उल्लेख करा.",
  nota: "वरीलपैकी काहीही नाही",
  yes: "हो",
  yesText: "असल्यास कृपया आम्हाला अधिक सांगा",
  no: "नाही",
  submitText1:
    "तुम्ही डॉक्टरांशी वैद्यकीय सत्रासाठी करण्यासाठी यशस्वीपणे नोंदणी केली आहे",
  submitText2: "माहिती सबमिट केली जात आहे. कृपया थांबा",
  submit: "सबमिट करा",
  updateInfo: "माहिती अपडेट करा",
  noInfo: "कोणतीही आरोग्य माहिती सादर केली नाही",
  loadingInfo: "आरोग्य माहिती मिळवत आहे",
  D1: {
    question: "तुमचं काम किंवा दररोजची हालचाल कशी आहे?",
    options: {
      D1C1: "बसून काम करणारे",
      D1C2: "हलकी शारीरिक हालचाल",
      D1C3: "खूप शारीरिक मेहनत लागणारे काम",
      D1C4: "बेरोजगार",
      D1C5: "निवृत्त",
      D1C6: "विद्यार्थी / विद्यार्थिनी",
      D1C7: "गृहिणी",
    },
  },
  D2: {
    question: "तुमचं काम शिफ्टमध्ये असतं का?",
    options: {
      D2C1: "फक्त दिवसाची शिफ्ट / नेहमी दिवसा काम",
      D2C2: "फक्त रात्रीची शिफ्ट / नेहमी राती काम",
      D2C3: "शिफ्ट फिरत्या पद्धतीने बदलते",
      D2C4: "कामाचा ठराविक वेळ नाही",
    },
  },
  D3: {
    question: "तुम्हाला खालीलपैकी कोणतीही पचनाची समस्या आहे का?",
    options: {
      D3C1: "पोट फुगणे",
      D3C2: "गॅस",
      D3C3: "बद्धकोष्ठता",
      D3C4: "पअ‍ॅसिडिटी",
      D3C5: "काहीही नाही",
    },
  },
  D4: {
    question: "तुम्हाला कुठल्या अन्नापासून अ‍ॅलर्जी आहे का?",
  },
  D5: {
    question: "तुम्ही यापैकी कोणत्याही गोष्टींचे सेवन करता का?",
    options: {
      D5C1: "दारू",
      D5C2: "तंबाखू",
      D5C3: "थंड / सोडायुक्त पेये (जसं की कोला, सॉफ्ट ड्रिंक्स)",
      D5C4: "काहीही नाही",
    },
  },
  D6: {
    question: "तुम्ही अन्न किती वेगाने चावता?",
    options: {
      D6C1: "हळू",
      D6C2: "मध्यम",
      D6C3: "जलद",
    },
  },
  D7: {
    question: "तुम्ही दररोज किती पाणी पिता?",
    options: {
      D7C1: "६ ग्लासपेक्षा कमी",
      D7C2: "६ ते ८ ग्लास",
      D7C3: "८ ग्लासपेक्षा जास्त",
    },
  },
  D8: {
    question: "तुमचं मानसिक तणाव किती आहे?",
    options: {
      D8C1: "तणाव नाही आहे",
      D8C2: "संवेदनशील स्वभाव",
      D8C3: "कमी",
      D8C4: "मध्यम",
      D8C5: "जास्त",
    },
  },
  D9: {
    question: "महिलांसाठी: कृपया मासिक पाळीची माहिती द्या.",
    options: {
      D9C1: "नियमित ",
      D9C2: "अनियमित",
      D9C3: "लागू होत नाही",
    },
  },
};
const hindiTranslations = {
  title: "आहार जानकारी",
  other: "अन्य",
  otherText: "अगर कोई अन्य है, तो कृपया इसका उल्लेख करें।",
  nota: "इनमे से कोई भी नहीं",
  yes: "हाँ",
  yesText: "यदि हां, तो कृपया हमें और बताएँ",
  no: "नहीं",
  submitText1:
    "आपने डॉक्टर के साथ चिकित्सा सत्र के लिए सफलतापूर्वक पंजीकरण कर लिया हैं",
  submitText2: "जानकारी जमा की जा रही है। कृपया प्रतीक्षा करें",
  submit: "इसे जमा करे",
  updateInfo: "जानकारी अपडेट करें|",
  noInfo: "कोई स्वास्थ्य सूचना प्रस्तुत नहीं की गई|",
  loadingInfo: "स्वास्थ्य की जानकारी प्राप्त कर रहे हैं|",
  D1: {
    question: "आपका काम या रोज़ की गतिविधि किस प्रकार की है?",
    options: {
      D1C1: "बैठकर किया जाने वाला",
      D1C2: "हल्की शारीरिक गतिविधि",
      D1C3: "शारीरिक रूप से मेहनत वाला",
      D1C4: "बेरोज़गार",
      D1C5: "सेवानिवृत्त",
      D1C6: "छात्र / छात्रा",
      D1C7: "गृहिणी",
    },
  },
  D2: {
    question: "क्या आपकी नौकरी शिफ्ट में होती है?",
    options: {
      D2C1: "सिर्फ दिन की शिफ्ट / हमेशा दिन में काम",
      D2C2: "सिर्फ रात की शिफ्ट / हमेशा रात में काम",
      D2C3: "शिफ्ट रोटेशन में बदलती है",
      D2C4: "काम का कोई निश्चित समय नहीं है",
    },
  },
  D3: {
    question:
      "क्या आपको इनमें से कोई पाचन संबंधी समस्या होती है?                        ",
    options: {
      D3C1: "पेट फूलना",
      D3C2: "गैस",
      D3C3: "कब्ज",
      D3C4: "एसिडिटी",
      D3C5: "इनमें से कुछ भी नहीं",
    },
  },
  D4: {
    question: "क्या आपको किसी खाने से एलर्जी है?",
  },
  D5: {
    question: "क्या आप इनमें से किसी चीज़ का सेवन करते हैं?",
    options: {
      D5C1: "शराब",
      D5C2: "तंबाकू",
      D5C3: "ठंडे / सोडा वाले ड्रिंक्स (जैसे कोला, सॉफ्ट ड्रिंक्स)",
      D5C4: "इनमें से कुछ भी नहीं",
    },
  },
  D6: {
    question: "आप खाना कितनी धीरे या जल्दी चबाते हैं?",
    options: {
      D6C1: "धीमा",
      D6C2: "मध्यम",
      D6C3: "तेज़",
    },
  },
  D7: {
    question: "आप रोज़ कितना पानी पीते हैं?",
    options: {
      D7C1: "6 गिलास से कम",
      D7C2: "6 से 8 गिलास",
      D7C3: "8 गिलास से ज़्यादा",
    },
  },
  D8: {
    question: "आपका मानसिक तनाव कितना है?",
    options: {
      D8C1: "तनाव नहीं है",
      D8C2: "संवेदनशील स्वभाव",
      D8C3: "कम",
      D8C4: "मध्यम",
      D8C5: "ज्यादा",
    },
  },
  D9: {
    question: "महिलाओं के लिए: कृपया मासिक धर्म से संबंधित जानकारी दें।",
    options: {
      D9C1: "नियमित",
      D9C2: "अनियमित",
      D9C3: "लागू नहीं होता",
    },
  },
};

export const translations = {
  EN: englishTranslations,
  MR: marathiTranslations,
  HI: hindiTranslations,
};
